import Aos from "../components/aos";
const PageEventsIndex = ($) => {
	if ($("body").hasClass("page-template-events-index")) {
		Aos();
	}
};

export default PageEventsIndex;
